import React from 'react';

const AUDIENCE = [
  'Final-year students',
  'Recent graduates',
  'First-year developers',
  'Career switchers into tech',
];

export default function F2FWhoIsItFor() {
  return (
    <section className="f2f-who">
      <div className="wrap">

        {/* Top: two-column */}
        <div className="f2f-who-top">
          <div className="f2f-who-left">
            <p className="f2f-who-eyebrow">Who it's for</p>
            <h2 className="f2f-who-heading">For anyone building a deliberate, AI-ready career.</h2>
            <p className="f2f-who-sub">
              Final-year students, recent graduates, and anyone in their first year of work
              who wants to plan their path — not leave it to chance.
            </p>
          </div>
          <div className="f2f-who-grid">
            {AUDIENCE.map((label) => (
              <div key={label} className="f2f-who-tag">{label}</div>
            ))}
          </div>
        </div>

        {/* Trainer card */}
        <div className="f2f-trainer-card">
          <div className="f2f-trainer-avatar" aria-hidden="true">CA</div>
          <div className="f2f-trainer-body">
            <div className="f2f-trainer-name-row">
              <span className="f2f-trainer-name">Chaitanya Allidona (Chai)</span>
              <span className="f2f-trainer-badge f2f-trainer-badge-green">Microsoft Certified Trainer</span>
              <span className="f2f-trainer-badge f2f-trainer-badge-red">GitHub Copilot certified</span>
            </div>
            <p className="f2f-trainer-bio">
              Founder of Lead With Tech. Chai has watched hundreds of grads stumble through their
              first two years — and built this roadmap from what actually works. He runs every
              session personally, and you can bring your questions to the live Q&amp;A.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}
